import { render, staticRenderFns } from "./author-card.vue?vue&type=template&id=1255b00c&scoped=true"
import script from "./author-card.vue?vue&type=script&lang=js"
export * from "./author-card.vue?vue&type=script&lang=js"
import style0 from "./author-card.vue?vue&type=style&index=0&id=1255b00c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1255b00c",
  null
  
)

export default component.exports